module.exports = __webpack_public_path__ + "img/banner.77e471d9.webp";